// Discovery Links — backed by GET /super-admin/discovery-links/overview.
// Period filtering now uses the shared PeriodValue/PeriodDropdown from
// '../../../components/period-filter' (All time/Monthly/Weekly/Daily/Custom Range).

export type DiscoverySort = "earnings_desc" | "date_created";

export const SORT_OPTIONS: { value: DiscoverySort; label: string }[] = [
  { value: "earnings_desc", label: "Earnings High - Low" },
  { value: "date_created", label: "Date Created" },
];

export type DiscoveryStatusFilter = "all" | "active" | "disabled";

export const STATUS_FILTER_OPTIONS: { value: DiscoveryStatusFilter; label: string }[] = [
  { value: "all", label: "All Links" },
  { value: "active", label: "Active Links" },
  { value: "disabled", label: "Disabled Links" },
];

export interface DiscoveryMetric {
  value: number;
  previous_value: number;
  change_absolute: number;
  change_percent: number | null;
}

export interface DiscoveryPerformance {
  links_generated: DiscoveryMetric;
  new_clicks_recorded: DiscoveryMetric;
  qualified_links: DiscoveryMetric;
}

export interface DiscoveryActivityItem {
  id: number;
  tracking_code: string;
  click_url: string;
  destination_url: string;
  domain: string;
  title: string;
  description: string | null;
  image_url: string | null;
  status: string;
  is_active: boolean;
  unique_click_count: number;
  reward_amount: number;
  earnings: number;
  recommender_id: number;
  recommender_name: string;
  recommender_email: string;
  created_at: string;
  qualified_at: string | null;
}

export interface DiscoveryOverviewResponse {
  status: boolean;
  period: string;
  performance: DiscoveryPerformance;
  total: number;
  limit: number;
  offset: number;
  activity: DiscoveryActivityItem[];
}
